export default "__VITE_ASSET__D$Vhs6$1__"